import React from "react";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useAuth } from "../hooks/useAuth";
import { Navigate, Outlet, Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import chaletStore from "../state/chaletstore";
import { disconnectws } from "../data/wsclient";


const Footer = () => {
  const lastUpdate = chaletStore((state) => state.data.lastUpdate);
  const isInitialized = chaletStore((state) => state.data.isInitilized);
  const live = chaletStore((state) => state.data.live);
  return (
    <footer className="page-footer font-small blue">
      Last updated: {lastUpdate}
      {isInitialized && !live && (
        <span className="ms-3 text-warning">Values from database, may be outdated</span>
      )}
    </footer>
  );
};

export const FramePage = ({ children }: any) => {
  const { logout } = useAuth();
  const resetInit = chaletStore((state) => state.resetInit)
  const handleLogout = () => {
    disconnectws()
    resetInit()
    logout();
  };

  const outside = chaletStore(state=>state.data.outside)

  const { token }: any = useAuth();
  if (!token) {
    console.log('not logged in',token)
    console.log(token)
    // user is not authenticated
    return <Navigate to="/login" />;
  }

  return (
    <div className="h-100">
      <Navbar expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
        <Container>
          <Navbar.Brand as={Link} to="/home">Chalet</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="groundfloor">Ground Floor</Nav.Link>
              <Nav.Link as={Link} to="firstfloor">First Floor</Nav.Link>
              <Nav.Link as={Link} to="settings">Settings</Nav.Link>
              <Nav.Link as={Link} to="history">History</Nav.Link>
            </Nav>
            <Navbar.Text className="me-5">
              Outside Temperature: {outside}
            </Navbar.Text>
            <Form>
              <Button
                data-bs-theme="dark"
                variant="outline-light"
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="h-100">
      <Outlet />
      </div>
      <Footer></Footer>
    </div>
  );
};
